"use client";

import React from "react";
import { Award, ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const painPoints = ["Sifting through unqualified inquiries that waste your precious time.", "Wrestling with outdated technology that fails to reflect your kennel's prestige.", "Struggling to maintain a digital presence that truly honors your bloodlines."];
export default function TheBreedersBurden() {
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="the-breeders-burden" className="bg-background py-24 lg:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          
          {}
          <div ref={imageRef} className={`relative w-full aspect-[4/5] lg:aspect-[3/4] rounded-3xl overflow-hidden shadow-2xl transition-all duration-1000 ease-out ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
            <div className="absolute inset-0 bg-primary/10 mix-blend-multiply z-10"></div>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1453987/img/soulful_bw_cavalier_portrait.png" alt="Soulful portrait of a Cavalier King Charles Spaniel" className="w-full h-full object-cover grayscale contrast-125 brightness-90" />
            {}
            <div className="absolute top-0 left-0 w-24 h-24 border-t-2 border-l-2 border-secondary/50 m-6 z-20 rounded-tl-xl"></div>
            <div className="absolute bottom-0 right-0 w-24 h-24 border-b-2 border-r-2 border-secondary/50 m-6 z-20 rounded-br-xl"></div>
          </div>

          {}
          <div ref={textRef} className={`flex flex-col justify-center transition-all duration-1000 delay-200 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <h2 className="font-serif text-5xl md:text-6xl lg:text-7xl text-primary font-bold tracking-tight mb-8">
              The Burden
            </h2>
            
            <div className="space-y-6 text-lg md:text-xl text-muted-foreground font-sans leading-relaxed mb-10">
              <p>
                You pour your heart, soul, and countless sleepless nights into every litter. Breeding is a legacy of love and an unwavering commitment to the standard.
              </p>
              <p>A strong breeder website does more than look nice. It helps puppy buyers understand your program, your dogs, your standards, and your process before they ever contact you. That matters because buyers are looking for health testing information, breeder experience, socialization practices, vaccination details, contract expectations, and an overall sense of transparency...which develops trust.</p>
            </div>

            <ul className="space-y-6 mb-12">
              {painPoints.map((point, index) => <li key={index} data-index={index} className="flex items-start gap-4 group">
                  <div className="mt-1 shrink-0 bg-secondary/10 p-2 rounded-full transition-colors group-hover:bg-secondary/20">
                    <Award className="w-6 h-6 text-secondary" strokeWidth={1.5} />
                  </div>
                  <span className="text-foreground/80 font-medium text-lg leading-snug pt-1">
                    {point}
                  </span>
                </li>)}
            </ul>

            <div className="pt-4 border-t border-border/50">
              <Button asChild variant="outline" size="lg" className="rounded-full border-secondary/50 text-primary hover:bg-secondary hover:text-secondary-foreground hover:border-secondary transition-all duration-300 group">
                <Link to="#">Book a Consultation<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-arrow-right ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" aria-hidden="true" data-ast-id="f:/src/pages/Home/sections/TheBreedersBurden.tsx|sig:jg8xpd" data-ast-start="4077" data-ast-end="4163"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg></Link>
              </Button>
            </div>

          </div>
        </div>
      </div>
    </section>;
}